export const ADMIN_TABS = [
  'conversations', 'users', 'invites', 'beta-access', 'wizard-promos',
  'lenses', 'properties', 'security', 'credits', 'guests', 'base44',
  'base44-external-apps', 'base44-health', 'apps', 'CopyService', 'Templates',
] as const;

export type AdminSection = typeof ADMIN_TABS[number];

export function canonicalAdminTab(tab: string | null): AdminSection {
  if (tab === 'operating-systems') return 'apps';
  return ADMIN_TABS.find((candidate) => candidate === tab) ?? 'apps';
}

export function withAdminTab(params: URLSearchParams, tab: AdminSection): URLSearchParams {
  const next = new URLSearchParams(params);
  next.set('tab', tab);
  return next;
}
